import { lazy } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { EditableHeading } from "@smartfire/components";
import {
  BlockWrapper,
  defineBlock,
  smartProps,
  useEditor,
  useInspectorControl,
} from "@smartfire/js-block-engine";
import clsx from "clsx";
import he from "he";
import { Product, SubMenu } from "../components";
import style from "./block.module.scss";

const Inspector = lazy(() => import("./Inspector"));

const Block = ({ universes, products }) => {
  const { isEditing } = useEditor();
  useInspectorControl(Inspector);

  const isMobile = useMediaQuery("(max-width: " + style.mobileBreakpoint + ")");
  const isTablet = useMediaQuery("(max-width: " + style.tabletBreakpoint + ")");
  const tilesPerView = isMobile ? 2 : isTablet ? 3 : 4;

  return (
    <BlockWrapper.Div className={style.block}>
      <div className={style.top}>
        <EditableHeading
          smartProp="title"
          placeholder="Current products"
          className={style.title}
        />

        {universes?.length > 0 && (
          <SubMenu arrowLeftBgColor={style.lightBeige}>
            {universes.map((universe) => (
              <a
                key={`universe-key-${universe.id}`}
                href={universe.link ?? undefined}
                className={style.universe}
              >
                {he.decode(universe.title) ?? ""}
              </a>
            ))}
          </SubMenu>
        )}
      </div>

      <div
        className={clsx(
          style.products,
          products?.length > tilesPerView && style.scroll
        )}
      >
        {isEditing && "List of products will be here (see preview)"}

        {products?.length > 0 &&
          products.map((product) => (
            <Product
              key={product.id}
              product={product}
              className={style.product}
            />
          ))}
      </div>
    </BlockWrapper.Div>
  );
};

export default defineBlock({
  Block,
  smartProps: {
    title: smartProps.object.withDefault({
      headingLevel: 2,
      content: "",
    }),
    selectedProducts: smartProps.array.withDefault([]),
    brandId: smartProps.number.withDefault(-1),
  },
  setup: {
    title: "Home Products",
  },
});
